import React from "react";
import { trackClickWhatsapp } from "../lib/tracking";

/**
 * WhatsApp Floating Action Button
 * - Clean inline SVG (Simple Icons – single path, no outline / no halo)
 * - Shadow applied to container only (icon is pure currentColor)
 * - Safe-area aware on iOS via env(safe-area-inset-bottom)
 * - Sits above the mobile StickyCTA (which is ~70px tall) without overlap
 */
export default function WhatsappFab() {
  const number = (process.env.REACT_APP_WHATSAPP_NUMBER || "40722100023").replace(/\D/g, "");
  const text = encodeURIComponent("Bună! Vreau detalii despre cursul AI pentru educație.");

  return (
    <a
      href={`https://wa.me/${number}?text=${text}`}
      target="_blank"
      rel="noreferrer noopener"
      onClick={trackClickWhatsapp}
      aria-label="Contactează-ne pe WhatsApp"
      data-testid="whatsapp-floating-button"
      style={{
        // Mobile: 6rem above the bottom edge (clears StickyCTA) + iOS safe-area inset.
        // Overridden on >=md screens via Tailwind class below.
        bottom: "calc(6rem + env(safe-area-inset-bottom, 0px))",
      }}
      className={[
        // positioning
        "fixed right-4 md:right-6 z-30",
        "md:!bottom-6", // desktop override (still respects safe-area on mobile)
        // size — perfectly circular
        "h-[52px] w-[52px] md:h-14 md:w-14",
        // visuals
        "rounded-full bg-[#25D366]",
        "flex items-center justify-center",
        "text-white",
        // shadow on container only
        "shadow-[0_8px_20px_-4px_rgba(37,211,102,0.45),0_4px_10px_-2px_rgba(0,0,0,0.18)]",
        "hover:shadow-[0_14px_28px_-4px_rgba(37,211,102,0.55),0_6px_14px_-2px_rgba(0,0,0,0.22)]",
        // motion
        "transition-[transform,box-shadow] duration-200 ease-out",
        "hover:-translate-y-0.5 hover:scale-[1.05]",
        "active:scale-95 active:translate-y-0",
        // accessibility
        "outline-none focus-visible:ring-4 focus-visible:ring-[#25D366]/40 focus-visible:ring-offset-2 focus-visible:ring-offset-white",
        // performance / artefact guard
        "will-change-transform [-webkit-tap-highlight-color:transparent]",
      ].join(" ")}
    >
      {/* Simple-Icons WhatsApp glyph (single path, scales cleanly, no outline) */}
      <svg
        viewBox="0 0 24 24"
        width="26"
        height="26"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        style={{ display: "block", filter: "none" }}
      >
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.075-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413" />
      </svg>
    </a>
  );
}
